var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgtrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19334 14.3867L5.25293 9.13374L0 7.19334L5.25293 5.25242L7.19334 0L9.13425 5.25242L14.3867 7.19334L9.13425 9.13374L7.19334 14.3867Z",
    fill: "#F0BB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1706 19.4954L17.868 15.9678L14.3403 14.6651L17.868 13.362L19.1706 9.83533L20.4738 13.362L24.0004 14.6651L20.4738 15.9678L19.1706 19.4954Z",
    fill: "#F0BB00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4797 23.9661L9.55266 21.4569L7.04297 20.5304L9.55266 19.6034L10.4797 17.0942L11.4067 19.6034L13.9164 20.5304L11.4067 21.4569L10.4797 23.9661Z",
    fill: "#F0BB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgtrace);
export default __webpack_public_path__ + "static/media/svgtrace.dff306a4e31d16e84d77d38752e005db.svg";
export { ForwardRef as ReactComponent };